import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useHistory } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    useMemo
} from 'react';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import styles from '../../pages/Administration/Administration.module.scss'
import metadata from './EditAgencyMailingAddress.metadata.json5';
import { useAuthentication } from '@xengage/gw-digital-auth-react';

function EditAgencyMailingAddress(props) {
    const { group, updateAgencyMailingAddress } = props;
    const history = useHistory();
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const [agencyMailing, setAgencyMailing] = useState();
    const viewModelService = useContext(ViewModelServiceContext);
    // DE15342 adding validation for submit
    const { onValidate, isComponentValid } =
    useValidation('EditAgencyMailingAddress');
    const [showErrors, setShowErrors] = useState(false)

    const cancel = useCallback(() => {
        history.go('/administration');
    }, [history]);

    // DE15378
    // eslint-disable-next-line react-hooks/exhaustive-deps, consistent-return
    const submit = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true)

            return false
        }

        updateAgencyMailingAddress(group);
    });

    const writeValue = useCallback(
        (value, path) => {

            _.set(group, path, value)
            setAgencyMailing(group);

            refreshData();
        },
        [group, refreshData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
            showErrors,
            showRequired: true,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            clickCancel: cancel,
            clickSubmit: submit

        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={group}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValueChange={writeValue}
            onValidationChange={onValidate}
        />
    );
}

EditAgencyMailingAddress.propTypes = {

};

EditAgencyMailingAddress.defaultProps = {

};

export default EditAgencyMailingAddress;
